import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@mui/material";
import { baseUrl } from "../../../../services/AzureStorage";
import ProfileImage from "../../../../sharedComponents/profileImage/profileImage";
import { useStyles } from "./UpdatePlayerDetails";

import * as React from "react";

const ParticipationTypeComponent = ({
  formData,
  commonEventList,
  handleOpenCloseUploadImage,
  checkIfParticipated,
  handleParticipationTypeChange,
  getJerseyNumber,
  handleJerseyNoInput,
}) => {
  const classes = useStyles();
  return (
    <>
      <Box>
        <Typography
          noWrap
          variant="subtitle1"
          className={classes.firstSectionTitle}
        >
          Personal Details
        </Typography>
      </Box>
      <Grid container pt={1} spacing={2}>
        <Grid item lg={4.8} md={4} sm={4} xs={12}>
          <Box display="flex" flexDirection="row" columnGap={2}>
            <ProfileImage
              handleClick={() => {
                handleOpenCloseUploadImage(true);
              }}
              src={baseUrl(formData.headshotURL)}
            />
            <Hidden smUp>
              <Typography
                variant="h6"
                sx={{ color: "#1d428a", alignSelf: "center" }}
              >
                {formData.playerName}
              </Typography>
            </Hidden>
          </Box>
        </Grid>
        <Grid item lg={7} md={8} sm={7.5} xs={12} sx={{ marginTop: "-2px" }}>
          <Grid container sx={{ display: "flex" }}>
            <Grid item lg={8} md={8.5} sm={8} xs={8}>
              <Typography noWrap variant="body2" sx={{ color: "#8B8B8B" }}>
                Participation Type
              </Typography>
            </Grid>
            <Grid item lg={4} md={3.5} sm={4} xs={4}>
              <Typography noWrap variant="body2" sx={{ color: "#8B8B8B" }}>
                Jersey #
              </Typography>
            </Grid>
          </Grid>
          {commonEventList.map((event, i) => {
            return (
              <Grid key={`pp_${i}`} container spacing={2}>
                <Grid item lg={8} md={8.5} sm={8} xs={8}>
                  <FormControl size="small" fullWidth margin="dense">
                    <FormControlLabel
                      value="end"
                      control={
                        <Checkbox
                          size="medium"
                          color="success"
                          checked={checkIfParticipated(event.eventId)}
                          onChange={() => {
                            handleParticipationTypeChange(event.eventId);
                          }}
                        />
                      }
                      label={event.eventName}
                      labelPlacement="end"
                      className={classes.label}
                    />
                  </FormControl>
                </Grid>
                <Grid item lg={4} md={3.5} sm={4} xs={4}>
                  <FormControl size="small" fullWidth margin="dense">
                    <TextField
                      size="small"
                      value={getJerseyNumber(event.eventId)}
                      disabled={!checkIfParticipated(event.eventId)}
                      onChange={(e) =>
                        handleJerseyNoInput(e.target.value, event.eventId)
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};
export default React.memo(ParticipationTypeComponent);
